{
	"branches": {
		"header": "Alle Filialen",
		"name": "Name",
		"type": "Typ",
		"contactPerson": "Ansprechpartner",
		"headOffice": "Hauptgeschäft",
		"onlineShop": "Online-Shop",
		"hint": "Alle Filialen",
		"byName": "Sortieren nach Name",
		"byHeadOffice": "Sortieren nach Hauptgeschäft",
		"byContactPerson": "Sortieren nach Ansprechpartner",
		"byType": "Sortieren nach Typ",
		"byOnlineShop": "Sortieren nach Online-Shop"
	},
	"branchDetails":{
		"title": "FilialDetails",
		"masterData": "Stammdaten",
		"name": "Name Geschäft, Gesellschaftsform",
		"headOffice": "Hauptgeschäft",
		"ownerOrManager": "Inhaber / Geschäftsführer",
		"contactPerson": "Ansprechpartner",
		"streetAndHouseNo": "Straße, Hausnummer",
		"country": "Land",
		"postalCode": "PLZ",
		"place": "Ort",
		"phone": "Telefon",
		"fax": "Fax",
		"email": "E-Mail",
		"website": "Webseite",
		"onlineShop": "Online-Shop",
		"openHours": "Öffnungszeiten",
		"weekday": "Wochentag",
		"morning": "Vormittag",
		"afternoon": "Nachmittag",
		"sunday": "Sonntag", 
		"monday": "Montag",
		"tuesday": "Dienstag",
		"wednesday": "Mittwoch",
		"thursday": "Donnerstag",
		"friday": "Freitag",
		"saturday": "Samstag",
		"timePlaceHolder": "HH:MM",
		"namePlaceHolder": "Foto Mustermann e.K.",
		"ownerOrManagerPlaceHolder": "Jens Mustermann Inhaber, Max Mustermann Geschäftsführer",
		"contactPersonPlaceHolder": "Konrad Kontaktmann",
		"streetAndHouseNoPlaceHolder": "Musterstraße 1",
		"postalCodePlaceHolder": "01234",
		"placePlaceHolder": "Ort",
		"phonePlaceHolder": "01234 / 567890",
		"faxPlaceHolder": "01234 / 567890",
		"emailPlaceHolder": "info@foto-mustermann.de",
		"websitePlaceHolder": "www.foto-mustermann.de",
		"messages": {
			"deleteSuccess": "Die Filiale {{branchName}} wurde erfolgreich gelöscht",
			"deleteMessage": " ",
			"deleteTitle": "Wollen Sie die Filiale wirklich löschen?",
			"deleteFailure": "Filiale konnte nicht gelöscht werden",
			"emptyList": "Die Liste ist leer"
		},
		"buttons":{
			"confirm": "Ok",
			"cancel": "Abbrechen",
			"edit": "Ändern",
			"delete": "Löschen",
			"save": "Speichern",
			"add": "Anlegen"
		},
		"countryCodes": {
			"DE": "Deutschland",
			"NL": "Niederlande",
			"AT": "Österreich",
			"IT": "Italien",
			"CH": "Schweiz"
		},
		"branchId": "Filial-ID",
		"branchVat": "Filial-Steuernummer",
		"branchSearchExport": "Filiale in Händlersuche",
		"branchVendorReporting": "Vendor Reporting relevant"
	},
	"branchesCreate": {
		"title": "Filiale anlegen",
		"createFailure": "Filiale konnte nicht angelegt werden.",
		"createSuccess": "Die Filiale {{branchName}} wurde erfolgreich angelegt."
	},
	"branchesEdit": {
		"title": "Filiale bearbeiten",
		"createFailure": "Filiale konnte nicht bearbeitet werden",
		"createSuccess": "Die Filiale {{branchName}} wurde erfolgreich geändert."
	},
	"breadcrumbs": {
		"details": "Filialen Übersicht",
		"child": "{{name}}"
	}
}